import React, { useState, useEffect } from 'react';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppMeterGroupsService from '../../AppMeterGroupsService';

//global component
import ModalButton from '../../../../shared/Buttons/ModalButton';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
  InputStyles,
  ModalNoteStyles,
} from '../../../../SharedStyles';

const VoltageModal = (props) => {
  const { handleCloseModal, handleDataChange } = props;
  const { strings } = AppMeterGroupsService;
  const [voltage, setVoltage] = useState('');

  useEffect(() => {
    setVoltage(props.voltage);
  }, [props.voltage]);

  const closeModal = () => {
    handleCloseModal();
  };

  const handleChange = (e) => {
    setVoltage(e.target.value);
  };

  const handleSaveInfo = (e) => {
    e.preventDefault();
    handleDataChange('voltage', voltage);
    handleCloseModal();
  };

  return (
    <ModalStyles>
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.voltageTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0'>
            <p>{strings.voltageContent}</p>
          </ModalItemStyles>
          {/* Section */}
          <form id='modalForm' onSubmit={handleSaveInfo}>
            <ModalItemStyles>
              <InputStyles
                type='number'
                onChange={handleChange}
                name='transformerPower'
                placeholder={strings.voltagePlaceholder}
                value={voltage || ''}
                required
              />
            </ModalItemStyles>
          </form>
          {/* Note Section */}
          <ModalNoteStyles>
            <p className='Warning-modal'>
              <span className='Warning-bold'>{strings.note}: </span>
              {strings.voltageNoteContent}
            </p>
          </ModalNoteStyles>
        </ModalContentStyles>
        {/* Button Component for Modals*/}
        <ModalButton
          containerMargin='10px 10px 0'
          containerAlign='right'
          buttonPadding='10px'
          buttonMargin='0'
          formSubmit='modalForm'
          buttonText={strings.ok}
        />
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default VoltageModal;
